export default "__VITE_ASSET__DGq0FaVF__"